import { Divider, Grid, Paper } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React from "react";


export function SkeletonLoading() {
    return <Paper style={{ padding: '2rem' }}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Skeleton variant="text" height={45} width={"50%"} animation="wave" />
                <Skeleton variant="text" height={25} width={"70%"} animation="wave" />
                <Divider style={{ marginTop: "0.5rem" }} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant='rect' height={50} animation="wave" />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant='rect' height={50} animation="wave" />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant='rect' height={50} animation="wave" />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant="text" height={45} width={"50%"} animation="wave" />
                <Skeleton variant="text" height={25} width={"70%"} animation="wave" />
                <Divider style={{ marginTop: "0.5rem" }} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant='rect' height={50} animation="wave" />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant='rect' height={80} animation="wave" />
            </Grid>
            <Grid item xs={4}>
                <Skeleton variant='rect' height={50} animation="wave" />
            </Grid>
            <Grid item xs={4}>
                <Skeleton variant='rect' height={50} animation="wave" />
            </Grid>
            <Grid item xs={4}>
                <Skeleton variant='rect' height={50} animation="wave" />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant='rect' height={50} animation="wave" />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant='rect' height={50} animation="wave" />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant='rect' height={50} animation="wave" />
            </Grid>
        </Grid>
    </Paper>;
}